// extracted by mini-css-extract-plugin
export var active = "_9r-7";
export var blink = "_9r-8";
export var dropDownSelector = "_9r-4";
export var dropDownWrapper = "_9r-3";
export var fakeCursor = "_9r-6";
export var fontSizeButton = "_9r-9";
export var formQuillEditor = "_9r-0";
export var pressed = "_9r-a";
export var qlBlank = "_9r-1";
export var textFormattingToolbar = "_9r-2";
export var textToolbarOption = "_9r-5";